import React from 'react'
import localReducer from './reducer'
import { NAME } from './constants'
import BarChart from './container/BarChart'
import { retrieveKpiSpec, retrieveContribElements, retrieveCAContribElements } from './actions'
import { getKpiSpec, getContribKeys, getCAContribKeys, getScatterGraphs } from './selectors'
import GoalBadge from './component/GoalBadge'
import { GoalCriteria } from './component/GoalCriteria'
// import { Route } from 'react-router-dom'
import Routes from './container/Routes'

const reducers = {
  [NAME]: localReducer,
}

const RouteOutageAnalysisContainer = ({ /* actionPermits, envConfig, */ kpiSpec }) => {
  return (
    <>
      {/* {(kpiSpec || []).map(({ id, metrics }) => {
        const Comp = () => <BarChart key={`${id}-content`} keys={metrics} />
        //
        return <Route key={id} exact path={`/${id}`} component={Comp} />
      })} */}
      <Routes kpiSpec={kpiSpec} />
    </>
  )
}

export {
  BarChart,
  retrieveKpiSpec,
  getKpiSpec,
  retrieveContribElements,
  retrieveCAContribElements,
  getContribKeys,
  getCAContribKeys,
  GoalBadge,
  GoalCriteria,
  getScatterGraphs,
  NAME,
  reducers,
  RouteOutageAnalysisContainer,
}

export default { NAME, reducers }
